import { useState } from 'react';

import Card from '../../../components/Card';
import Radio from '../../../components/Radio';
import * as CardStyles from '../../../components/Card/Card.styles';

import Top8ValueSector from './Top8ValueSector';
import Top8VolumeSector from './Top8VolumeSector';

const chartViewOptions = [
  {
    value: 'klgd',
    label: 'Theo Khối Lượng Giao Dịch',
  },
  {
    value: 'gtgd',
    label: 'Theo Giá Trị Giao Dịch',
  },
];

export default function HighlightStockBySector({
  top8VolumeSector,
  top8ValueSector,
}) {
  const [chartViewOption, setChartViewOption] = useState(
    chartViewOptions[0].value
  );
  const handleTradingChange = (_value) => {
    setChartViewOption(_value);
  };

  const getTitle = () => {
    return (
      <div className="flex justify-between items-center highlight-stockup-header">
        <CardStyles.CardTitle>Cổ Phiếu Nổi Bật Theo Ngành</CardStyles.CardTitle>
        <div className="inline-flex">
          <Radio
            name="chartViewOption"
            options={chartViewOptions}
            defaultValue={chartViewOption || tradingOptions[0].value}
            onChange={handleTradingChange}
          />
        </div>
      </div>
    );
  };
  return (
    <Card customTitle={getTitle()}>
      <div className="mt-3">
        {chartViewOption === chartViewOptions[0].value ? (
          <Top8VolumeSector
            isLoading={top8VolumeSector.isTradingVolumeBySectorLoading}
            data={top8VolumeSector.topTradingVolumeBySectorData}
            isDarkMode={top8VolumeSector.isDarkMode}
            handleTooltipOpen={top8VolumeSector.handleOpenTop10Tooltip}
            top8ChartData={top8VolumeSector.chartDataByCode}
            isInvestmentCategoriesLoading={
              top8VolumeSector.isInvestmentCategoriesLoading
            }
            authenticated={top8VolumeSector.authenticated}
            investmentCategories={top8VolumeSector.investmentCategories}
            followCompanies={top8VolumeSector.followCompanies}
            saveInvestmentCategory={top8VolumeSector.saveInvestmentCategory}
            deleteInvestmentCategory={top8VolumeSector.deleteInvestmentCategory}
            investmentCategoriesMessage={
              top8VolumeSector.investmentCategoriesMessage
            }
            isOpeningBookmark={top8VolumeSector.isOpeningBookmark}
            handleSetIsOpeningBookmark={
              top8VolumeSector.handleSetIsOpeningBookmark
            }
            setSelectedChartPeriod={top8VolumeSector.setSelectedChartPeriod}
            handlesSelectedChartPeriodChange={
              top8VolumeSector.handlesSelectedChartPeriodChange
            }
            selectedChartPeriod={top8VolumeSector.selectedChartPeriod}
            setSelectedDataChartModal={
              top8VolumeSector.setSelectedDataChartModal
            }
            setChartModalShow={top8VolumeSector.setChartModalShow}
            isChartDataByCodeLoading={top8VolumeSector.isChartDataByCodeLoading}
          />
        ) : (
          <Top8ValueSector
            isLoading={top8ValueSector.isTradingValueBySectorLoading}
            data={top8ValueSector.topTradingValueBySectorData}
            isDarkMode={top8ValueSector.isDarkMode}
            handleTooltipOpen={top8ValueSector.handleOpenTop10Tooltip}
            top8ChartData={top8ValueSector.chartDataByCode}
            isInvestmentCategoriesLoading={
              top8ValueSector.isInvestmentCategoriesLoading
            }
            authenticated={top8ValueSector.authenticated}
            investmentCategories={top8ValueSector.investmentCategories}
            followCompanies={top8ValueSector.followCompanies}
            saveInvestmentCategory={top8ValueSector.saveInvestmentCategory}
            deleteInvestmentCategory={top8ValueSector.deleteInvestmentCategory}
            investmentCategoriesMessage={
              top8ValueSector.investmentCategoriesMessage
            }
            isOpeningBookmark={top8ValueSector.isOpeningBookmark}
            handleSetIsOpeningBookmark={
              top8ValueSector.handleSetIsOpeningBookmark
            }
            setSelectedChartPeriod={top8ValueSector.setSelectedChartPeriod}
            handlesSelectedChartPeriodChange={
              top8ValueSector.handlesSelectedChartPeriodChange
            }
            selectedChartPeriod={top8ValueSector.selectedChartPeriod}
            setSelectedDataChartModal={
              top8ValueSector.setSelectedDataChartModal
            }
            setChartModalShow={top8ValueSector.setChartModalShow}
            isChartDataByCodeLoading={top8ValueSector.isChartDataByCodeLoading}
          />
        )}
      </div>
    </Card>
  );
}
